














import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AccomodationUnitTypeForm from "./AccomodationUnitTypeForm.vue";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { AmenityView } from "@/shared/models/amenities";
import { AccomodationUnitTypesWithDetailsView } from '@/shared/models/accomodationUnitTypesWithDetailsView';

@Component({
  components: {
    AccomodationUnitTypeForm,
    RightDrawer,
  },
})
export default class AccomodationUnitTypeDrawer extends Vue {
  @Prop() open?: boolean;
  @Prop() accomodationUnitType?: { accomodationUnitTypeId: number };

  @Watch("accomodationUnitType")
  async accomodationUnitTypeChanged(fresh: { accomodationUnitTypeId: number }) {
    if (fresh) {
      await this.loadDetails(fresh);
    } else {
      this.details = {
        accomodationUnitTypeAmenities: [] as AmenityView[],
        propertyAmenities: [] as AmenityView[],
      };
    }
  }

  details?: Partial<AccomodationUnitTypesWithDetailsView> = {
    accomodationUnitTypeAmenities: [] as AmenityView[],
    propertyAmenities: [] as AmenityView[],
  };

  async loadDetails({
    accomodationUnitTypeId,
  }: {
    accomodationUnitTypeId: number;
  }) {
    const response = await this.axios.get(
      `accomodationUnitTypes/${accomodationUnitTypeId}`
    );
    this.details = response.data;
  }
}
